import {
    CheckoutAPIProduct,
    RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"

export const sizeLabelsFunction = (productItems: { name: string }[]): string[] => {
    return Array.isArray(productItems) ? productItems.map(item => item.name) : []
}

export const productHelperFunction = (
    product: any,
    availableSizesContext: any,
    fit_type_fit_type?: string[]
) => {
    const isLensGuide = product?.lens_guide_type
    const isSizeGuide = product?.size_guide_type
    const productColorName = product?.color_swatch?.color_name
    const productLensName = product?.lens?.lens_name

    const isAvailableButNotSelected = availableSizesContext.some(
        (size: { isAvailable: boolean; isSelected: boolean }) =>
            size.isAvailable && !size.isSelected
    )
    const isAnySizeSelected = availableSizesContext.some(
        (size: { isSelected: boolean }) => size.isSelected
    )
    const isSelectedSizeAvailable = availableSizesContext.some(
        (size: { isSelected: boolean; isAvailable: boolean }) =>
            size.isSelected && size.isAvailable
    )

    const isOneSize =
        availableSizesContext.length === 1 &&
        availableSizesContext[0]?.name === "One Size"

    // Using optional chaining and nullish coalescing to ensure safety
    const isFitType =
        fit_type_fit_type?.[0] !== "0" && (fit_type_fit_type?.length ?? 0) > 0

    const sizeLabels = sizeLabelsFunction(product.items || [])

    return {
        isLensGuide,
        isSizeGuide,
        productColorName,
        productLensName,
        isAvailableButNotSelected,
        isAnySizeSelected,
        isSelectedSizeAvailable,
        isOneSize,
        isFitType,
        sizeLabels
    }
}

export function hasColorSwatch(
    products: (CheckoutAPIProduct | RelatedProduct)[]
): boolean {
    return products.some(product => product.color_swatch !== undefined)
}
